import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../store';
import { firestore, firestoreQuery } from '../firebase';
import { PhotoSource, PhotoStatus, UserPhoto } from '../types';


interface Filters {
  status?: PhotoStatus | 'all',
  source?: PhotoSource | 'all',
}

interface PhotosState {
  photos: UserPhoto[];
  loading: boolean;
  loadingMore: boolean;
  cursor?: any;
  filters: Filters;
}

const initialState: PhotosState = {
  photos: [],
  loading: false,
  loadingMore: false,
  filters: {
  },
}



const filtersChanged = (a: Filters, b: Filters) => {
  return a.source !== b.source || a.status !== b.status;
}

const service = createSlice({
  name: 'photos',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>): PhotosState {
      return { ...state, loading: action.payload, }
    },
    setLoadingMore(state, action: PayloadAction<boolean>): PhotosState {
      return { ...state, loadingMore: action.payload, }
    },
    setPhotos(state, action: PayloadAction<UserPhoto[]>): PhotosState {
      return {
        ...state,
        photos: [
          ...state.photos,
          ...action.payload,
        ]
      }
    },
    resetPhotos(state): PhotosState {
      return {
        ...state,
        photos: []
      }
    },
    setCursor(state, action: PayloadAction<any>): PhotosState {
      return {
        ...state,
        cursor: action.payload,
      }
    },
    setFilters(state, action: PayloadAction<Filters>): PhotosState {
      return {
        ...state,
        filters: { ...action.payload },
      }
    },
  }
});

const loadList = (filters: Filters, loadingMore: boolean): AppThunk => async (dispatch, getState) => {
  const state = getState().photos;
  let cursor = state.cursor;

  if (!filtersChanged(filters, state.filters) && !loadingMore) {
    return;
  }

  if (loadingMore && !cursor) {
    return;
  }

  console.log('load photos', filters, `loadMore: ${loadingMore}`);

  if (filtersChanged(filters, state.filters)) {
    dispatch(service.actions.resetPhotos());
    dispatch(service.actions.setFilters(filters));
    dispatch(service.actions.setCursor(null));
    cursor = null;
  }

  if (loadingMore) {
    dispatch(service.actions.setLoadingMore(true));
  }
  else {
    dispatch(service.actions.setLoading(true));
  }

  let query = firestore.collectionGroup('profile_photos').orderBy('createTime', 'desc').limit(50);
  if (cursor) {
    query = query.startAfter(cursor);
  }

  if (filters.status !== 'all') {
    query = query.where('status', '==', filters.status);
  }
  if (filters.source !== 'all') {
    query = query.where('source', '==', filters.source);
  }

  const result = await firestoreQuery<UserPhoto>(query);

  dispatch(service.actions.setCursor(result.lastItem));
  dispatch(service.actions.setPhotos(result.list));

  if (loadingMore) {
    dispatch(service.actions.setLoadingMore(false));
  }
  else {
    dispatch(service.actions.setLoading(false));
  }

}




export const actions = {
  loadList,
}

export default service.reducer;